var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VModalWrapper',_vm._g(_vm._b({attrs:{"title":_vm.title}},'VModalWrapper',_vm.attributes,false),_vm.listeners),[_c('p',{staticClass:"error-model__message"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]),_c('VButton',{staticClass:"button_green-light",attrs:{"type":"button"},on:{"click":_vm.hide}},[_vm._v(" Закрыть ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }